module.exports = __webpack_public_path__ + "static/media/_MIC2408.thumbnail.aa7cfcf5.png";